<div
    class="d-flex justify-content-center align-items-center h-100"
    *ngIf="isLoading"
>
    <div class="tryb-design-spinner"></div>
</div>
<div id="scene-content" class="row" *ngIf="!isLoading">
    <div class="col-2" id="sticky-sidebar">
        <div class="text-center left-sidebar">
            <div class="left-sidebar__item">
                <app-scene-composition
                    [trainingId]="trainingId"
                    [editingIsDisabled]="editingIsDisabled"
                ></app-scene-composition>
            </div>
            <div class="left-sidebar__item">
                <app-scene-import
                    [trainingId]="trainingId"
                    [editingIsDisabled]="editingIsDisabled"
                    [robotId]="robotId"
                ></app-scene-import>
            </div>
        </div>
    </div>
    <div class="col-8 canv">
        <div class="canvas-container" #container></div>
    </div>
    <div class="col-2" id="context-area">
        <div class="context-area-content">
            <app-context-area
                [trainingId]="trainingId"
                [editingIsDisabled]="editingIsDisabled"
            ></app-context-area>
        </div>
    </div>
</div>
